import { localToUtcTime } from '@ourbranch/date-helpers';
import {
  coverageRSExtendedForcedStates,
  coverageRSForcedStates,
  extendedCoverageRSExpirationByAgeStateExclusions,
  noShowRoofSurfacesExtendedUnderXYearsStates,
  getRoofAgeLimit
} from '@ourbranch/roof-helpers';
import { awsDateToDateObject } from 'core/helpers/formatters';
import { useStore } from 'core/store';

const useExtendedRoofCoverage = (home, state, fromPolicy, initialValues, coverageRSExtended) => {
  const { account, offer: offerStore } = useStore();
  if (!home) {
    return null;
  }
  const policyStore = account?.policies?.policy;

  const roofAgeLimit = getRoofAgeLimit({ roofType: home.roofType, state });

  const dateToCheckAgainst = fromPolicy
    ? new Date(localToUtcTime(policyStore?.policy.effectiveDate, state))
    : awsDateToDateObject(offerStore?.offer?.quote?.global.rateControlDate);

  const roofAge = dateToCheckAgainst.getFullYear() - home.roofYear;

  const forcedStandardRSCoverage =
    coverageRSForcedStates[state] ||
    (!extendedCoverageRSExpirationByAgeStateExclusions[state] &&
      // check that we are not in a policy that has extended coverage in AR/GA because we dont want to force a lesser coverage
      !(fromPolicy && noShowRoofSurfacesExtendedUnderXYearsStates[state] && coverageRSExtended) &&
      roofAge > roofAgeLimit);

  const forcedExtendedRSCoverage =
    coverageRSExtendedForcedStates[state] ||
    (noShowRoofSurfacesExtendedUnderXYearsStates[state] &&
      roofAge <= noShowRoofSurfacesExtendedUnderXYearsStates[state]);

  // dont lock the roof choice if there is no change in value
  const inPolicyAndRoofYearUnchanged = fromPolicy && home.roofYear === initialValues.home.roofYear;

  // honor policies already bound this way
  const policyBoundWithRoofExtendedSoWeHaveToHonorIt = fromPolicy && initialValues.homeCoverage.coverageRSExtended;

  // check if the value is what we expect in policy
  const isCurrentValueCorrectValueInPolicy =
    fromPolicy &&
    ((forcedStandardRSCoverage && !coverageRSExtended) || (forcedExtendedRSCoverage && coverageRSExtended));

  const lockedRSField =
    fromPolicy &&
    !noShowRoofSurfacesExtendedUnderXYearsStates[state] &&
    !isCurrentValueCorrectValueInPolicy &&
    (inPolicyAndRoofYearUnchanged || policyBoundWithRoofExtendedSoWeHaveToHonorIt)
      ? false
      : forcedStandardRSCoverage || forcedExtendedRSCoverage || false;

  return {
    lockedRSField,
    forcedStandardRSCoverage,
    forcedExtendedRSCoverage,
    isCurrentValueCorrectValueInPolicy,
    policyBoundWithRoofExtendedSoWeHaveToHonorIt
  };
};
export default useExtendedRoofCoverage;
